import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "main-content type4" };
const _hoisted_2 = { class: "content-wrapper" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = {
    key: 1,
    class: "select-date"
};
const _hoisted_5 = { class: "cy-date-picker brg-input-section multi-date-picker-activator" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "mt-2" };
import { computed, onMounted, onUnmounted, ref, } from 'vue';
import { routeName } from '@/constants/routeName';
import { useRoute, useRouter, } from 'vue-router';
import CardSection from '@/components/Common/CardSection.vue';
import { storeToRefs } from 'pinia';
import vuexStore from '@/vuex-store';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { i18n } from '@/locales';
import { alertActionType } from '@/vuex-store/alert/actions';
import InputRow from '@/components/Form/InputRow.vue';
import { objDeepCompare } from '@/utils/object';
import { createWorkerNoticeFormRule } from '@/form/form-rules/workerNotice';
import { format } from 'date-fns';
import dateFormatType from '@/constants/dateFormatType';
import { pStore } from '@/pinia';
import { formatDate } from '@/utils';
import { autoLcWorkerNotice } from '@/locales/ko/views/worker_notice';
import BoardFooter from '@/components/Common/BoardFooter.vue';
import { getFormValueForPinia, setFormValueForPinia, } from '@/utils/form';
import SubController from './SubController.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        // PAGE: 라이더 공지사항 등록, 수정
        const lc = autoLcWorkerNotice();
        const formRule = createWorkerNoticeFormRule();
        const route = useRoute();
        const router = useRouter();
        const pWorkerNotice = pStore.piniaWorkerNotice;
        const pGlobal = pStore.piniaGlobal;
        const { itemDetail, formData, originFormData, workerList, selectedDateText, } = storeToRefs(pWorkerNotice);
        const pageId = route.params.workerNoticeId;
        const isEditPage = !!pageId;
        const { urlHistory, } = storeToRefs(pGlobal);
        const confirm = (payload) => vuexStore.dispatch(alertActionType.confirm, payload);
        const minDate = ref(new Date());
        const userName = computed(() => (itemDetail.value.userName ? itemDetail.value.userName : vuexStore.state.user.userInfo.name));
        /**
         * 취소 클릭 핸들러
         */
        const handleClickReturnBtn = async () => {
            const isSameData = objDeepCompare(originFormData.value, formData.value, [
                'hubId',
                'distributorId',
            ]);
            // 수정페이지면 상세보기, 등록페이지면 목록 페이지로 간다.
            // eslint-disable-next-line no-nested-ternary
            const name = pageId
                ? urlHistory.value === routeName.WORKER_NOTICE
                    ? routeName.WORKER_NOTICE
                    : routeName.WORKER_NOTICE_DETAIL
                : routeName.WORKER_NOTICE;
            const params = pageId ? {
                workerNoticeId: pageId,
            } : {};
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const routeData = {
                name,
                query: route.query,
                params,
            };
            if (isSameData) {
                router.push(routeData).catch(() => { });
                return;
            }
            const isConfirmOk = await confirm({
                headerTitle: i18n.t('common.cancel'),
                bodyContent: i18n.t('common.confirm_before_cancel'),
            });
            if (isConfirmOk) {
                router.push(routeData).catch(() => { });
            }
        };
        const formRef = ref(null);
        /** 기간 선택 */
        const period = ref([
            {
                key: 1,
                value: 'ALL',
                label: '전체',
            },
            {
                key: 2,
                value: 'BETWEEN',
                label: '기간',
            },
        ]);
        /**
         * 허브 리스트
         */
        const hubList = computed(() => {
            const _hubList = vuexStore.state.hubSelector.hubs;
            return [
                {
                    key: 'ALL',
                    text: '전체 허브 라이더',
                },
                ..._hubList,
            ];
        });
        /** 대상 선택 */
        const workerTargetType = ref([
            {
                key: 1,
                label: '소속 라이더 전체',
                value: 'ALL',
            },
            {
                key: 2,
                label: '라이더 선택',
                value: 'BY_WORKER',
            },
        ]);
        /**
         * 시작일자 클릭 핸들러
         */
        const handleClickStartDate = (value) => {
            formData.value.selectedDate[0] = format(value, dateFormatType.DATE);
            formData.value.selectedDate[1] = '';
        };
        /**
         * 종료일자 클릭 핸들러
         */
        const handleClickEndDate = (last) => {
            // 나중에 클릭한게 더 이르면 데이터 스왑
            if (last < new Date(formData.value.selectedDate[0])) {
                // eslint-disable-next-line prefer-destructuring
                formData.value.selectedDate[1] = formData.value.selectedDate[0];
                formData.value.selectedDate[0] = format(last, dateFormatType.DATE);
            }
            else {
                formData.value.selectedDate[1] = format(last, dateFormatType.DATE);
            }
        };
        /**
         * 피커 승인 버튼 핸들러
         */
        const handleClickPickerSubmit = () => {
            // 하나만 클릭한 상태에선 같은 날로 입력
            if (formData.value.selectedDate[1] === '') {
                // eslint-disable-next-line prefer-destructuring
                formData.value.selectedDate[1] = formData.value.selectedDate[0];
            }
            pWorkerNotice.updateDateText();
        };
        /**
         * 캘린더 취소 닫기 버튼 클릭 핸들러
         */
        const handleClickClosedBtn = () => { };
        /**
         * 전송
         */
        const handleSubmitForm = async () => {
            const { valid } = await formRef.value.validate();
            if (!valid) {
                return;
            }
            // api 호출
            try {
                const result = pageId
                    ? await pWorkerNotice.updateNotice()
                    : await pWorkerNotice.createNotice();
                vuexStore.dispatch(snackbarActionType.showSuccess, i18n.t('common.success'));
                router.push({
                    name: routeName.WORKER_NOTICE_DETAIL,
                    params: {
                        workerNoticeId: pageId || result.data.id,
                    },
                    query: route.query,
                }).catch(() => { });
            }
            catch (error) {
                console.log('workerNotice/handleSubmitForm', error);
                vuexStore.dispatch(snackbarActionType.showError);
            }
        };
        /**
         * 허브의 워커 리스트 호출
         */
        const getWorkerList = async () => {
            try {
                await pWorkerNotice.getWorkerList();
            }
            catch (error) {
                console.log('workerNotice/getWorkerList', error);
                vuexStore.dispatch(snackbarActionType.showError);
            }
        };
        /**
         * 상세 조회
         */
        const getNotice = async (_id) => {
            try {
                const response = await pWorkerNotice.getNotice(_id);
                pWorkerNotice.setFormData(response);
            }
            catch (error) {
                console.log('workerNotice/getNotice', error);
                vuexStore.dispatch(snackbarActionType.showError);
            }
        };
        /**
         * 허브 선택 이벤트 핸들러
         */
        const handleUpdateSelectedHub = () => {
            if (formData.value.selectedHub === 'ALL') {
                formData.value.targetType = 'ALL';
                formData.value.selectedWorkerList = [];
                return;
            }
            getWorkerList();
            formData.value.selectedWorkerList = [];
        };
        const getFormValue = (key) => getFormValueForPinia(formData, key);
        const setFormValue = (key, value) => setFormValueForPinia(formData, key, value);
        /**
         * 페이지 초기화
         */
        onMounted(async () => {
            pWorkerNotice.updateDateText();
            // 상세 페이지 케이스
            if (pageId) {
                await getNotice(pageId);
            }
            formData.value.distributorId = vuexStore.state.user.hubInfo.distributorId;
        });
        onUnmounted(() => {
            pWorkerNotice.clear();
        });
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_radio = _resolveComponent("v-radio");
            const _component_v_radio_group = _resolveComponent("v-radio-group");
            const _component_vue_datepicker_action_row = _resolveComponent("vue-datepicker-action-row");
            const _component_vue_datepicker = _resolveComponent("vue-datepicker");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_autocomplete = _resolveComponent("v-autocomplete");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_form, {
                    ref_key: "formRef",
                    ref: formRef,
                    onSubmit: _withModifiers(handleSubmitForm, ["prevent"])
                }, {
                    default: _withCtx(() => [
                        _createVNode(SubController),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(CardSection, null, {
                                titleContent: _withCtx(() => [
                                    _createCommentVNode(" 제목 "),
                                    _createVNode(InputRow, {
                                        "input-row-class": "",
                                        label: _unref(i18n).t('common.text_title')
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                                class: "cy-title",
                                                density: "comfortable",
                                                variant: "outlined",
                                                "hide-details": "auto",
                                                "validate-on": "blur",
                                                rules: _unref(formRule).title,
                                                placeholder: "제목을 입력해 주세요.",
                                                "model-value": getFormValue('title'),
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => setFormValue('title', value))
                                            }, null, 8 /* PROPS */, ["rules", "model-value"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["label"])
                                ]),
                                default: _withCtx(() => [
                                    _createVNode(InputRow, {
                                        class: "brg-input-section-dense-wrapper",
                                        label: "작성자"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(userName.value), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(InputRow, {
                                        class: _normalizeClass(isEditPage ? 'brg-input-section-dense-wrapper' : ''),
                                        label: "기간"
                                    }, {
                                        default: _withCtx(() => [
                                            isEditPage
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                    (_unref(itemDetail).noticePeriodType === 'SELECTED')
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createTextVNode(_toDisplayString(_unref(formatDate)(_unref(itemDetail).noticeStart, _unref(dateFormatType).FULL_DATE_MINUTE)) + " ~ " + _toDisplayString(_unref(formatDate)(_unref(itemDetail).noticeEnd, _unref(dateFormatType).FULL_DATE_MINUTE)), 1 /* TEXT */)
                                                        ], 64 /* STABLE_FRAGMENT */))
                                                        : _createCommentVNode("v-if", true),
                                                    (_unref(itemDetail).noticePeriodType === 'ENDLESS')
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _createTextVNode(_toDisplayString(_unref(lc)('detail.endless')), 1 /* TEXT */)
                                                        ], 64 /* STABLE_FRAGMENT */))
                                                        : _createCommentVNode("v-if", true)
                                                ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                    _createElementVNode("div", null, [
                                                        _createVNode(_component_v_radio_group, {
                                                            inline: "",
                                                            name: "periodTypeRadio",
                                                            density: "compact",
                                                            "hide-details": "",
                                                            "model-value": getFormValue('periodType'),
                                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => setFormValue('periodType', value))
                                                        }, {
                                                            default: _withCtx(() => [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(period.value, (option) => {
                                                                    return (_openBlock(), _createBlock(_component_v_radio, {
                                                                        class: _normalizeClass(`cy-period-type-radio-${option.key}`),
                                                                        key: option.key,
                                                                        value: option.value,
                                                                        label: option.label
                                                                    }, null, 8 /* PROPS */, ["class", "value", "label"]));
                                                                }), 128 /* KEYED_FRAGMENT */))
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["model-value"])
                                                    ]),
                                                    _createCommentVNode(" 달력 "),
                                                    _createVNode(_component_vue_datepicker, {
                                                        disabled: _unref(formData).periodType === 'ALL',
                                                        "model-value": _unref(formData).selectedDate,
                                                        range: "",
                                                        format: "yyyy-MM-dd",
                                                        "min-date": minDate.value,
                                                        onRangeStart: handleClickStartDate,
                                                        onRangeEnd: handleClickEndDate,
                                                        "onUpdate:modelValue": handleClickPickerSubmit,
                                                        onClosed: handleClickClosedBtn
                                                    }, {
                                                        "action-row": _withCtx((props) => [
                                                            _createVNode(_component_vue_datepicker_action_row, _normalizeProps(_guardReactiveProps(props)), null, 16 /* FULL_PROPS */)
                                                        ]),
                                                        "dp-input": _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_5, [
                                                                _createVNode(_component_v_text_field, {
                                                                    disabled: _unref(formData).periodType === 'ALL',
                                                                    value: _unref(selectedDateText),
                                                                    variant: "outlined",
                                                                    density: "compact",
                                                                    readonly: "",
                                                                    "hide-details": "",
                                                                    class: "cy-cal-input",
                                                                    "bg-color": "white",
                                                                    "prepend-inner-icon": "mdi-calendar-month-outline"
                                                                }, null, 8 /* PROPS */, ["disabled", "value"])
                                                            ])
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["disabled", "model-value", "min-date"])
                                                ]))
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["class"]),
                                    _createVNode(InputRow, {
                                        class: _normalizeClass(isEditPage ? 'brg-input-section-dense-wrapper' : ''),
                                        label: "대상"
                                    }, {
                                        default: _withCtx(() => [
                                            _createCommentVNode(" 수정 페이지 "),
                                            isEditPage
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                    (_unref(itemDetail).workerNoticeTargetType === 'BY_WORKER')
                                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(itemDetail).selectedWorkerList, ({ name, code }, key) => {
                                                            return (_openBlock(), _createBlock(_component_v_chip, {
                                                                key: key,
                                                                title: code,
                                                                class: "mr-1",
                                                                color: "primary",
                                                                variant: "outlined"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(name), 1 /* TEXT */)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                        : _createCommentVNode("v-if", true),
                                                    (_unref(itemDetail).workerNoticeTargetType === 'WORKER_OF_DISTRIBUTOR')
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _createTextVNode(" 전체 허브 라이더 ")
                                                        ], 64 /* STABLE_FRAGMENT */))
                                                        : _createCommentVNode("v-if", true),
                                                    (_unref(itemDetail).workerNoticeTargetType === 'WORKER_OF_HUB')
                                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                                            key: 2,
                                                            title: _unref(itemDetail).hub.code,
                                                            class: "mr-1",
                                                            color: "primary",
                                                            variant: "outlined"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_unref(itemDetail).hub.name) + " 허브 전체 라이더 ", 1 /* TEXT */)
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["title"]))
                                                        : _createCommentVNode("v-if", true)
                                                ]))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createCommentVNode(" 등록 페이지 "),
                                                    _createCommentVNode(" 허브 선택 "),
                                                    (!isEditPage)
                                                        ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                                                            key: 0,
                                                            disabled: isEditPage,
                                                            modelValue: _unref(formData).selectedHub,
                                                            "onUpdate:modelValue": [
                                                                _cache[2] || (_cache[2] = ($event) => ((_unref(formData).selectedHub) = $event)),
                                                                handleUpdateSelectedHub
                                                            ],
                                                            "item-title": "text",
                                                            "item-value": "key",
                                                            items: hubList.value,
                                                            variant: "outlined",
                                                            density: "compact",
                                                            "hide-details": "auto"
                                                        }, null, 8 /* PROPS */, ["modelValue", "items"]))
                                                        : _createCommentVNode("v-if", true),
                                                    _createCommentVNode(" 라이더 전체 여부 "),
                                                    _createElementVNode("div", _hoisted_7, [
                                                        _createVNode(_component_v_radio_group, {
                                                            inline: "",
                                                            name: "deliveryChargeRadio",
                                                            density: "compact",
                                                            "hide-details": "",
                                                            "model-value": getFormValue('targetType'),
                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = (value) => setFormValue('targetType', value))
                                                        }, {
                                                            default: _withCtx(() => [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workerTargetType.value, (option) => {
                                                                    return (_openBlock(), _createBlock(_component_v_radio, {
                                                                        key: option.key,
                                                                        label: option.label,
                                                                        value: option.value,
                                                                        disabled: (option.key === 2 && _unref(formData).selectedHub === 'ALL')
                                                                    }, null, 8 /* PROPS */, ["label", "value", "disabled"]));
                                                                }), 128 /* KEYED_FRAGMENT */))
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["model-value"])
                                                    ]),
                                                    _createCommentVNode(" 라이더 선택 "),
                                                    (_unref(formData).targetType !== 'ALL')
                                                        ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                                                            key: 1,
                                                            chips: "",
                                                            "closable-chips": "",
                                                            multiple: "",
                                                            class: "mt-2",
                                                            "item-title": "name",
                                                            "item-value": "code",
                                                            modelValue: _unref(formData).selectedWorkerList,
                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(formData).selectedWorkerList) = $event)),
                                                            items: _unref(workerList),
                                                            variant: "outlined",
                                                            density: "compact",
                                                            "hide-details": "auto",
                                                            placeholder: "공지사항을 받을 라이더를 선택해 주세요.",
                                                            rules: _unref(formRule).workerList
                                                        }, null, 8 /* PROPS */, ["modelValue", "items", "rules"]))
                                                        : _createCommentVNode("v-if", true)
                                                ], 64 /* STABLE_FRAGMENT */))
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["class"]),
                                    _createVNode(InputRow, { label: "내용" }, {
                                        default: _withCtx(() => [
                                            _createCommentVNode(" 본문 "),
                                            _createVNode(_component_v_textarea, {
                                                class: "cy-body",
                                                variant: "outlined",
                                                rows: "10",
                                                "row-height": "20",
                                                "hide-details": "auto",
                                                placeholder: "내용을 입력해 주세요.",
                                                "validate-on": "blur",
                                                rules: _unref(formRule).body,
                                                "model-value": getFormValue('body'),
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = (value) => setFormValue('body', value))
                                            }, null, 8 /* PROPS */, ["rules", "model-value"])
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _createCommentVNode(" footer "),
                        _createVNode(BoardFooter, null, {
                            left: _withCtx(() => [
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickReturnBtn }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                                                _createTextVNode(" mdi-chevron-left ")
                                            ])),
                                            _: 1 /* STABLE */,
                                            __: [6]
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_unref(i18n).t('common.back_to_list')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            info: true,
                                            outlined: true,
                                            "size-l": true,
                                            "width-xs": true
                                        }
                                    ]
                                ])
                            ]),
                            right: _withCtx(() => [
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickReturnBtn }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(i18n).t('common.cancel')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            info: true,
                                            outlined: true,
                                            "size-l": true,
                                            "width-xs": true
                                        }
                                    ]
                                ]),
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                    type: "submit",
                                    class: "cy-submit-btn ml-2"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { small: "" }, {
                                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                _createTextVNode(" mdi-check ")
                                            ])),
                                            _: 1 /* STABLE */,
                                            __: [7]
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_unref(i18n).t('common.done')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            primary: true,
                                            "width-s": true,
                                            "size-l": true,
                                            "width-xs": true
                                        }
                                    ]
                                ])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */)
            ]));
        };
    }
});
